import Vue from "vue";
import FileSaver from "file-saver";
import contentDisposition from "content-disposition";

const apiGatewayGET = async function(url) {
  return Vue.prototype.axios.get(url, await getHeaders()).then(response => {
    return response.data;
  });
};

const apiGatewayPOST = async function(url, building) {
  return Vue.prototype.axios
    .post(url, building, await getHeaders())
    .then(response => {
      return response.data;
    });
};

const apiGatewayPUT = async function(url, object) {
  return Vue.prototype.axios
    .put(url, object, await getHeaders())
    .then(response => {
      return response.data;
    });
};

const apiGatewayPATCH = async function(url, object) {
  return Vue.prototype.axios
    .patch(url, object, await getHeaders())
    .then(response => {
      return response.data;
    });
};

const apiGatewayDELETE = async function(url) {
  return Vue.prototype.axios.delete(url, await getHeaders()).then(response => {
    return response.data;
  });
};

const apiGatewayBLOB = async function(url) {
  return Vue.prototype.axios.get(url, await getBlobHeaders()).then(response => {
    var filename = contentDisposition.parse(
      response.request.getResponseHeader("Content-Disposition")
    );
    FileSaver.saveAs(response.data, filename.parameters.filename);
  });
};

const getHeaders = async function() {
  return {
    headers: {
      Authorization: "Bearer " + (await Vue.prototype.$auth.getTokenSilently())
    }
  };
};

const getBlobHeaders = async function() {
  return {
    headers: {
      Authorization: "Bearer " + (await Vue.prototype.$auth.getTokenSilently())
    },
    responseType: "blob"
  };
};

export const apiGateway = {
  apiGatewayGET,
  apiGatewayPOST,
  apiGatewayPUT,
  apiGatewayPATCH,
  apiGatewayDELETE,
  apiGatewayBLOB
};
